// src/components/sections/hero.js
export default function Hero() {
  return null;
}
